import { call, put, takeLatest } from "redux-saga/effects";
import Module from "../../modules/contents/edit";
import "babel-polyfill";
import axios from "../axios";

function* updateContents(action) {
  try {
    const result = yield call(
      function(contentsForApi, foreignKeyId, model) {
        const body = JSON.stringify({
          contents: contentsForApi,
          foreign_key_id: foreignKeyId,
          model: model,
        });
        return axios
          .post("/api/content/update_contents", body)
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            throw error;
          });
      },
      action.payload.contentsForApi,
      action.payload.foreignKeyId,
      action.payload.model
    );
    if (result) {
      yield put(
        Module.actions.updateSuccess({
          updateStatus: "success",
          contents: result,
        })
      );
    } else {
      yield put(
        Module.actions.updateFailure({
          modalIsOpen: true,
          updateStatus: "error",
        })
      );
    }
  } catch (e) {
    yield put(Module.actions.updateFailure({ updateStatus: "error" }));
  }
}

function* loadContents(action) {
  try {
    const result = yield call(
      function(foreignKeyId, model) {
        const body = JSON.stringify({
          foreign_key_id: foreignKeyId,
          model: model,
        });
        return axios
          .post("/api/content/load_contents", body)
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            throw error;
          });
      },
      action.payload.foreignKeyId,
      action.payload.model
    );
    if (result) {
      yield put(
        Module.actions.loadSuccess({
          loadStatus: "success",
          contents: result,
        })
      );
    } else {
      yield put(
        Module.actions.loadFailure({
          loadStatus: "error",
          contents: [],
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.loadFailure({
        loadStatus: "error",
        contents: [],
      })
    );
  }
}

function* uploadContentImage(action) {
  try {
    const result = yield call(
      function(foreignKeyId, file, model, contentId) {
        let formData = new FormData();
        formData.append("foreign_key_id", foreignKeyId);
        formData.append("file", file);
        formData.append("model", model);
        formData.append("id", contentId);
        return axios
          .post("/api/content/upload_content_image", formData)
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            throw error;
          });
      },
      action.payload.foreignKeyId,
      action.payload.file,
      action.payload.model,
      action.payload.contentId
    );
    if (result) {
      yield put(
        Module.actions.uploadContentImageSuccess({
          imgUpload: true,
          uploadContentImageStatus: "success",
          contents: result,
        })
      );
    } else {
      yield put(
        Module.actions.uploadContentImageFailure({
          imgUpload: true,
          uploadContentImageStatus: "error",
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.uploadContentImageFailure({
        imgUpload: true,
        uploadContentImageStatus: "error",
      })
    );
  }
}

function* loadCourses() {
  try {
    const result = yield call(function() {
      return axios
        .post("/api/courses/load_courses")
        .then(function(response) {
          return response.data;
        })
        .catch(function(error) {
          throw error;
        });
    });
    if (result) {
      yield put(
        Module.actions.loadCoursesSuccess({
          loadCoursesStatus: "success",
          courses: result,
        })
      );
    } else {
      yield put(
        Module.actions.loadCoursesFailure({
          loadCoursesStatus: "error",
          courses: [],
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.loadCoursesFailure({
        loadCoursesStatus: "error",
        courses: [],
      })
    );
  }
}

function* loadCoursesContents(action) {
  try {
    const result = yield call(function(courseId) {
      const body = JSON.stringify({
        course_id: courseId,
      });
      return axios
        .post("/api/courses/load_contents", body)
        .then(function(response) {
          return response.data;
        })
        .catch(function(error) {
          throw error;
        });
    }, action.payload.courseId);
    if (result) {
      yield put(
        Module.actions.loadCoursesContentsSuccess({
          loadCoursesContensStatus: "success",
          coursesContents: result,
        })
      );
    } else {
      yield put(
        Module.actions.loadCoursesContentsFailure({
          loadCoursesContensStatus: "error",
          coursesContents: [],
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.loadCoursesContentsFailure({
        loadCoursesContensStatus: "error",
        coursesContents: [],
      })
    );
  }
}

export default function*() {
  yield takeLatest(Module.actions.updateContents, updateContents);
  yield takeLatest(Module.actions.uploadContentImage, uploadContentImage);
  yield takeLatest(Module.actions.loadContents, loadContents);
  yield takeLatest(Module.actions.loadCourses, loadCourses);
  yield takeLatest(Module.actions.loadCoursesContents, loadCoursesContents);
}
